import { render } from "./Cart_Option_Item.vue?vue&type=template&id=5b3136b8"
import script from "./Cart_Option_Item.vue?vue&type=script&lang=js"
export * from "./Cart_Option_Item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__